import { render, staticRenderFns } from "./Logins.vue?vue&type=template&id=6bdd1e92"
import script from "./Logins.vue?vue&type=script&lang=js"
export * from "./Logins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports